import React from "react";
import Typography from "@mui/material/Typography";

const AutomaticallyCalculatedLabel = () => {
  return (
    <Typography
      variant="caption"
      style={{ display: "inline", whiteSpace: "nowrap", color: "gray" }}
    >
      （自動計算）
    </Typography>
  );
};

export default AutomaticallyCalculatedLabel;
